export const Account = state => state.Account;
export const GuestToken = state => state.GuestToken;
export const Child = state => state.Child;
export const Agency = state => state.Agency;
export const CaseWorker = state => state.CaseWorker;
export const DefaultAgency = state => state.DefaultAgency;
export const MyFamilies = state => state.MyFamilies;
export const MyChildren = state => state.MyChildren;
export const JSONData = state => state.JSONData;
export const ChildrenJSONData = state => state.ChildrenJSONData;
export const DashboardFamilies = state => state.DashboardFamilies;
export const DashboardFamiliesLoaded = state => state.DashboardFamiliesLoaded;
export const AgencyList = state => state.AgencyList;
export const AgenciesRequiredPayment = state => state.AgenciesRequiredPayment;
export const Country = state => state.Country;
export const State = state => state.State;
export const Video = state => state.Video;
export const Album = state => state.Album;
export const AlbumPhotosPopulated = state => state.AlbumPhotosPopulated;
export const AlbumLoaded = state => state.AlbumLoaded;
export const AlbumPhoto = state => state.AlbumPhoto;
export const ProfileDocument = state => state.ProfileDocument;
export const ProfileDocumentList = state => state.ProfileDocumentList;
export const ProfileDocConversation = state => state.ProfileDocConversation;
export const PhotoDownload = state => state.PhotoDownload;
export const Blog = state => state.Blog;
export const Letter = state => state.Letter;
export const Request = state => state.Request;
export const Template = state => state.Template;
export const TemplateItem = state => state.TemplateItem;
export const TemplateArray = state => state.TemplateArray;
export const File = state => state.File;
export const FileLoaded = state => state.FileLoaded;
export const Task = state => state.Task;
export const Timeline = state => state.Timeline;
export const TimelineLoaded = state => state.TimelineLoaded;
export const IsSubscriptionActive = state => state.IsSubscriptionActive;
export const IsSubscriptionActiveLoaded = state => state.IsSubscriptionActiveLoaded;
export const TimelineIcons = state => state.TimelineIcons;
export const PdfTemplate = state => state.PdfTemplate;
export const PdfTemplateLoaded = state => state.PdfTemplateLoaded;
export const Message = state => state.Message;
export const MessageLoaded = state => state.MessageLoaded;
export const CountsLoaded = state => state.CountsLoaded;
export const AuthorizeTransactionReport = state => state.AuthorizeTransactionReport;
export const AuthorizeNetFutureTransaction = state => state.AuthorizeNetFutureTransaction;
export const MessageGroup = state => state.MessageGroup;
export const Conversation = state => state.Conversation;
export const ArchiveConversation = state => state.Conversation;
export const ConversationLoaded = state => state.ConversationLoaded;
export const AllAccount = state => state.AllAccount;
export const ContactList = state => state.ContactList;
export const Human = state => state.Human;
export const BlogCategory = state => state.BlogCategory;
export const BlogSettings = state => state.BlogSettings;
export const VideoList = state => state.VideoList;
export const HelpVideoLoaded = state => state.HelpVideoLoaded;
export const Feedback = state => state.Feedback;
export const Faq = state => state.Faq;
export const FaqLoaded = state => state.FaqLoaded;
export const AdminDashboardCounts = state => state.AdminDashboardCounts;
export const MyAgencies = state => state.MyAgencies;
export const Survey = state => state.Survey;
export const SurveyLoaded = state => state.SurveyLoaded;
export const ClientDomains = state => state.ClientDomains;
export const EmailTemplate = state => state.EmailTemplate;
export const WebsiteTemplate = state => state.WebsiteTemplate;
export const GoogleAd = state => state.GoogleAd;
export const GroupCampaign = state => state.GroupCampaign;
export const PaymentMode = state => state.PaymentMode;
export const Campaign = state => state.Campaign;
export const CampaignReport = state => state.CampaignReport;
export const CampaignDetailedReport = state => state.CampaignDetailedReport;
export const DataUpdateRequest = state => state.DataUpdateRequest;
export const MenuSettings = state => state.MenuSettings;
export const Project = state => state.Project;
export const AllProject = state => state.AllProject;
export const Log = state => state.Log;
export const SearchResult = state => state.SearchResult;
export const FileCategory = state => state.FileCategory;
export const DocumentList = state => state.DocumentList;
export const AdminList = state => state.AdminList;
export const appVersionList = state => state.appVersionList;
export const HelpFileList = state => state.HelpFileList;
export const Music = state => state.Music;
export const BadgeContact = state => state.BadgeContact;
export const AgencyAccount = state => state.AgencyAccount;
export const ChildGroup = state => state.ChildGroup;


// WEBPACK FOOTER //
// ./src/store/getters.js